import {
  CloseOutlined,
  AddOutlined,
  InsertDriveFileOutlined
} from '@mui/icons-material';
import { CircularProgress, Stack, Typography } from '@mui/material';

import { EToasterStatus, showToast } from '../../utils/showToast';

import {
  IMPORT_CSV_FILE_DESCRIPTION,
  IMPORT_CSV_FILE_HEADER,
  IMPORT_CSV_FILE_MESSAGE
} from './constants/constants';
import { ImportCSVContentProps } from './types';

import './style.scss';
import Button from 'components/Button/Button';
import { FontAwesomeIcon } from '@appcharge/shared-ui';

const ImportCSVContent = ({
  isUploading,
  fileRef,
  setFieldValue
}: ImportCSVContentProps) => {
  const handleFileChange = (event: any) => {
    const file = event.currentTarget.files[0];
    if (file.type !== 'text/csv') {
      showToast({
        message: IMPORT_CSV_FILE_MESSAGE,
        status: EToasterStatus.ERROR
      });
      return;
    }
    setFieldValue('file', file);
  };

  const handleDrop = (event: React.DragEvent) => {
    event.preventDefault();
    const files = event.dataTransfer.files;
    if (files.length > 0) {
      const file = files[0];
      if (file.type !== 'text/csv') {
        showToast({
          message: IMPORT_CSV_FILE_MESSAGE,
          status: EToasterStatus.ERROR
        });
        return;
      }
      setFieldValue('file', file);
      if (fileRef.current) {
        const dataTransfer = new DataTransfer();
        dataTransfer.items.add(file);
        fileRef.current.files = dataTransfer.files;
      }
    }
  };

  const handleDragOver = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleDragEnter = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const handleDragLeave = (event: React.DragEvent) => {
    event.preventDefault();
  };

  const calculateFileSizeDisplay = (sizeInBytes: number) => {
    const sizeInKB = sizeInBytes / 1024;
    if (sizeInKB < 1024) {
      return sizeInKB.toFixed(2) + ' KB';
    } else {
      const sizeInMB = sizeInKB / 1024;
      return sizeInMB.toFixed(2) + ' MB';
    }
  };

  return (
    <div style={{ fontFamily: `'Montserrat', sans-serif` }}>
      <div>
        <input
          style={{ display: 'none' }}
          type="file"
          ref={fileRef}
          accept=".csv"
          onChange={handleFileChange}
        />
        <Stack
          style={{ position: 'relative' }}
          height="288px"
          bgcolor="#F4F4F5"
          border="1px solid #E4E4E7"
          justifyContent="center"
          alignItems="center"
          borderRadius={2}
          gap={1}
          onDrop={handleDrop}
          onDragOver={handleDragOver}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          {isUploading ? (
            <CircularProgress />
          ) : !!fileRef?.current?.files?.length ? (
            <>
              <CloseOutlined
                className="close-icon"
                style={{
                  width: '16px',
                  height: '16px',
                  backgroundColor: 'transparent'
                }}
                sx={{
                  cursor: 'pointer'
                }}
                onClick={(event) => {
                  event.stopPropagation();
                  if (fileRef.current) {
                    fileRef.current.value = '';
                  }
                  setFieldValue('file', null);
                }}
              />
              <FontAwesomeIcon
                icon="fa-solid fa-file"
                style={{
                  fontSize: '34px',
                  height: '34px',
                  width: '34px',
                  color: '#3F3F46'
                }}
              />
              <div className="file-name">{fileRef?.current?.files[0].name}</div>
              <div className="file-size">
                {calculateFileSizeDisplay(fileRef.current.files[0].size)}
              </div>
            </>
          ) : (
            <>
              <Typography
                fontFamily="'Montserrat', sans-serif"
                variant="body1"
                color="#4F46E5"
                fontSize="18px"
                fontWeight="500"
              >
                {IMPORT_CSV_FILE_HEADER}
              </Typography>
              <Typography
                fontFamily="'Montserrat', sans-serif"
                variant="body1"
                color="textSecondary"
                fontSize="14px"
                style={{
                  marginTop: '-6px',
                  marginBottom: '12px'
                }}
              >
                {IMPORT_CSV_FILE_DESCRIPTION}
              </Typography>
              <div className="upload-button-container">
                <Button
                  variant="outline"
                  type="button"
                  onClick={() => {
                    fileRef?.current?.click();
                  }}
                  className="upload-button"
                  style={{
                    fontSize: '14px',
                    borderTopRightRadius: '0px',
                    borderBottomRightRadius: '0px'
                  }}
                >
                  Upload
                </Button>
                <Button
                  variant="outline"
                  type="button"
                  onClick={() => {
                    fileRef?.current?.click();
                  }}
                  leftIcon={
                    <AddOutlined style={{ width: '24px', height: '24px' }} />
                  }
                  className="upload-button"
                  style={{
                    maxHeight: '40px',
                    maxWidth: '36px',
                    borderTopLeftRadius: '0px',
                    borderBottomLeftRadius: '0px',
                    marginLeft: '1px'
                  }}
                ></Button>
              </div>
            </>
          )}
        </Stack>
      </div>
    </div>
  );
};
export default ImportCSVContent;
